import React, { useEffect } from 'react';

import styled from '@emotion/styled';

import Card from '../../../components/Cards/Card';
import BookmarkCheckIcon from '../../../components/Icons/BookmarkCheckIcon';
import BookmarkMinusIcon from '../../../components/Icons/BookmarkMinusIcon';
import useDriverInfoStats from '../../../hooks/dashboard/user-management/driveInfoStats';
import { useAppSelector } from '../../../redux/store';

const DriverInfoStats = () => {
  const { dashboardStatsData } = useAppSelector((state) => state.dashboardData);
  const { driverInfoStats: fetchDriverInfoStats } = useDriverInfoStats();

  useEffect(() => {
    fetchDriverInfoStats('');
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <CardContainerWrapper>
        {/* Card 1 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <BookmarkCheckIcon /> No of active drivers
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.activePartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>

        {/* Card 2 */}
        <Card.Root padding='12px 24px'>
          <Card.Header padding='12px'>
            <BookmarkMinusIcon /> No of exited drivers
          </Card.Header>
          <Card.Body>
            <Card.LargeNumber type='default'>
              {dashboardStatsData?.deletedPartners ?? 0}
            </Card.LargeNumber>
          </Card.Body>
        </Card.Root>
      </CardContainerWrapper>
    </Container>
  );
};

export default DriverInfoStats;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

const CardContainerWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  height: 160px;
`;
